import { render } from "./CRMWhatsappContactNoteDialog.vue?vue&type=template&id=326e7d8f"
import script from "./CRMWhatsappContactNoteDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactNoteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__